import safeCreateAction from "../../actions/safeCreateAction";
export const showOverlay = safeCreateAction("SHOW_INSTRUCTIONS", (id, title, content, componentId, pos, options) => ({ id, title, content, componentId, pos, options }));
export const dismissOverlay = safeCreateAction("DISMISS_INSTRUCTIONS", (id) => id);
